module.exports = __webpack_public_path__ + "img/vote-5@2x.7d3d54a5.png";